import { useEffect, useState } from "react"
import { fetchApi } from "../../utils/fetchApi";
import Loader from "../../components/Loader";
import ReactECharts from 'echarts-for-react'; 
import ReactSwitch from "react-switch";

export default function CustomerStats({id}) {
    const [isLoading, setIsLoading] = useState(true);
    const [isMonthly, setIsMonthly] = useState(true);
    const [stats, setStats] = useState([]);

    useEffect(() => {
        setIsLoading(true)
        let url = `stti/users-login/${id}`;

        if (isMonthly) {
            url = `${url}?monthly=1`
        }

        fetchApi(url, null, 'GET').then((data) => {
            setStats(data);        
        }).finally(() => {
            setIsLoading(false)
        })
    }, [id, isMonthly])

    if (isLoading) {
        return <Loader />
    }

    if (stats.length === 0) {
        return <p>Aucune stats</p>
    }

    const option = {
    tooltip: {
      trigger: "axis",
    },
    xAxis: {
      type: "category",
      data: Object.keys(stats),
      axisLabel: {
        rotate: 45,
      },
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: Object.values(stats),
        type: "line",
        smooth: true,
        areaStyle: {}, // optional: fills the area under the curve
      },
    ],
  };

  return <>
    <div style={{display: "flex"}}>
        <label style={{display: "flex", alignItems: "center", gap: 10, cursor: "pointer"}}><ReactSwitch size={1} checked={isMonthly} onChange={() => setIsMonthly(prev => !prev)}/> Mensuel</label>
    </div>
    <ReactECharts option={option} style={{ height: 400 }} />
  </>;
}